import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getPagesAboutEramanDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  aboutUs : [
  {
    fieldName: "Title (EN)",
    fieldValue: "title",
    className: "col-span-6",
    type: "text",
    name: "title",
    formType: "input",
    label: "Title (EN)",
    placeholder: "Enter Title (EN)",
    validation: { required: "Title (EN) is required" },
  },
  {
    fieldName: "Title (MS)",
    fieldValue: "titleMs",
    className: "col-span-6",
    type: "text",
    name: "titleMs",
    formType: "input",
    label: "Title (MS)",
    placeholder: "Enter Title (MS)",
  },
  {
    fieldName: "Title (ZH)",
    fieldValue: "titleZh",
    className: "col-span-6",
    type: "text",
    name: "titleZh",
    formType: "input",
    label: "Title (ZH)",
    placeholder: "Enter Title (ZH)",
  },
  // {
  //   fieldName: "Airport Name",
  //   fieldValue: "airportName",
  //   className: "col-span-6",
  //   type: "text",
  //   name: "airportName",
  //   formType: "input",
  //   label: "Airport Name",
  //   placeholder: "Enter Airport Name",
  //   validation: { required: "Airport Name is required" },
  // },
  {
    fieldName: "Description (EN)",
    fieldValue: "field_content_description_en",
    className: "col-span-6",
    type: "text",
    name: "field_content_description_en",
    formType: "richText",
    label: "Description (EN)",
    placeholder: "Enter Description (EN)",
    validation: { required: "Description (EN) is required" },
  },
  {
    fieldName: "Description (MS)",
    fieldValue: "field_content_description_ms",
    className: "col-span-6",
    type: "text",
    name: "field_content_description_ms",
    formType: "richText",
    label: "Description (MS)",
    placeholder: "Enter Description (MS)",
  },
  {
    fieldName: "Description (ZH)",
    fieldValue: "field_content_description_zh",
    className: "col-span-6",
    type: "text",
    name: "field_content_description_zh",
    formType: "richText",
    label: "Description (ZH)",
    placeholder: "Enter Description (ZH)",
  },
 
  // Vision
  {
    fieldName: "Vision Icon",
    fieldValue: "visionIcon",
    className: "col-span-6",
    type: "image",
    name: "visionIcon",
    formType: "file",
    usedFileType: 'image/*',
    label: "Vision Icon",
    placeholder: "Upload Vision Icon",
    validation: { required: "Vision Icon is required" },
    imageDimension: {
      width: 96,
      height: 96
    }
  },
  {
    fieldName: "Vision Title (EN)",
    fieldValue: "visionTitle",
    className: "col-span-6",
    type: "text",
    name: "visionTitle",
    formType: "input",
    label: "Vision Title",
    placeholder: "Enter Vision Title (EN)",
    validation: { required: "Vision Title (EN) is required" },
  },
  {
    fieldName: "Vision Title (MS)",
    fieldValue: "visionTitleMs",
    className: "col-span-6",
    type: "text",
    name: "visionTitleMs",
    formType: "input",
    label: "Vision Title (MS)",
    placeholder: "Enter Vision Title (MS)",
  },
  {
    fieldName: "Vision Title (ZH)",
    fieldValue: "visionTitleZh",
    className: "col-span-6",
    type: "text",
    name: "visionTitleZh",
    formType: "input",
    label: "Vision Title (ZH)",
    placeholder: "Enter Vision Title (ZH)",
  },
  {
    fieldName: "Vision Description (EN)",
    fieldValue: "visionDesc",
    className: "col-span-6",
    type: "text",
    name: "visionDesc",
    formType: "richText",
    label: "Vision Description (EN)",
    placeholder: "Enter Vision Description (EN)",
    validation: { required: "Vision Description (EN) is required" },
  },
  {
    fieldName: "Vision Description (MS)",
    fieldValue: "visionDescMs",
    className: "col-span-6",
    type: "text",
    name: "visionDescMs",
    formType: "richText",
    label: "Vision Description (MS)",
    placeholder: "Enter Vision Description (MS)",
  },
  {
    fieldName: "Vision Description (ZH)",
    fieldValue: "visionDescZh",
    className: "col-span-6",
    type: "text",
    name: "visionDescZh",
    formType: "richText",
    label: "Vision Description (ZH)",
    placeholder: "Enter Vision Description (ZH)",
  },
 
  // Mission
  {
    fieldName: "Mission Icon",
    fieldValue: "missionIcon",
    className: "col-span-6",
    type: "image",
    name: "missionIcon",
    formType: "file",
    usedFileType: 'image/*',
    label: "Mission Icon",
    placeholder: "Upload Mission Icon",
    validation: { required: "Mission Icon is required" },
    imageDimension: {
        width: 96,
        height: 96 
      }
  },
  {
    fieldName: "Mission Title (EN)",
    fieldValue: "missionTitle",
    className: "col-span-6",
    type: "text",
    name: "missionTitle",
    formType: "input",
    label: "Mission Title",
    placeholder: "Enter Mission Title (EN)",
    validation: { required: "Mission Title (EN) is required" },
  },
  {
    fieldName: "Mission Title (MS)",
    fieldValue: "missionTitleMs",
    className: "col-span-6",
    type: "text",
    name: "missionTitleMs",
    formType: "input",
    label: "Mission Title (MS)",
    placeholder: "Enter Mission Title (MS)",
  },
  {
    fieldName: "Mission Title (ZH)",
    fieldValue: "missionTitleZh",
    className: "col-span-6",
    type: "text",
    name: "missionTitleZh",
    formType: "input",
    label: "Mission Title (ZH)",
    placeholder: "Enter Mission Title (ZH)",
  },
  {
    fieldName: "Mission Description (EN)",
    fieldValue: "missionDesc",
    className: "col-span-6",
    type: "text",
    name: "missionDesc",
    formType: "richText",
    label: "Mission Description (EN)",
    placeholder: "Enter Mission Description (EN)",
    validation: { required: "Mission Description (EN) is required" },
  },
  {
    fieldName: "Mission Description (MS)",
    fieldValue: "missionDescMs",
    className: "col-span-6",
    type: "text",
    name: "missionDescMs",
    formType: "richText",
    label: "Mission Description (MS)",
    placeholder: "Enter Mission Description (MS)",
  },
  {
    fieldName: "Mission Description (ZH)",
    fieldValue: "missionDescZh",
    className: "col-span-6",
    type: "text",
    name: "missionDescZh",
    formType: "richText",
    label: "Mission Description (ZH)",
    placeholder: "Enter Mission Description (ZH)",
  },
 
  // Core Values
  {
    fieldName: "Core Icon",
    fieldValue: "coreValuesIcon",
    className: "col-span-6",
    type: "image",
    name: "coreValuesIcon",
    formType: "file",
    usedFileType: 'image/*',
    label: "Core Icon",
    placeholder: "Upload Core Icon",
    validation: { required: "Core Icon is required" },
    imageDimension: {
        width: 96,
        height: 96
      }
  },
  {
    fieldName: "Core Title (EN)",
    fieldValue: "coreValuesTitle",
    className: "col-span-6",
    type: "text",
    name: "coreValuesTitle",
    formType: "input",
    label: "Core Title (EN)",
    placeholder: "Enter Core Title (EN)",
    validation: { required: "Core Title (EN) is required" },
  },
  {
    fieldName: "Core Title (MS)",
    fieldValue: "coreValuesTitleMs",
    className: "col-span-6",
    type: "text",
    name: "coreValuesTitleMs",
    formType: "input",
    label: "Core Title (MS)",
    placeholder: "Enter Core Title (MS)",
  },
  {
    fieldName: "Core Title (ZH)",
    fieldValue: "coreValuesTitleZh",
    className: "col-span-6",
    type: "text",
    name: "coreValuesTitleZh",
    formType: "input",
    label: "Core Title (ZH)",
    placeholder: "Enter Core Title (ZH)",
  },
  {
    fieldName: "Core Description (EN)",
    fieldValue: "coreValuesDesc",
    className: "col-span-6",
    type: "text",
    name: "coreValuesDesc",
    formType: "richText",
    label: "Core Description (EN)",
    placeholder: "Enter Core Description (EN)",
    validation: { required: "Core Description (EN) is required" },
  },
  {
    fieldName: "Core Description (MS)",
    fieldValue: "coreValuesDescMs",
    className: "col-span-6",
    type: "text",
    name: "coreValuesDescMs",
    formType: "richText",
    label: "Core Description (MS)",
    placeholder: "Enter Core Description (MS)",
  },
  {
    fieldName: "Core Description (ZH)",
    fieldValue: "coreValuesDescZh",
    className: "col-span-6",
    type: "text",
    name: "coreValuesDescZh",
    formType: "richText",
    label: "Core Description (ZH)",
    placeholder: "Enter Core Description (ZH)",
  },
 
  // Video
  {
    fieldName: "Video",
    fieldValue: "videoUrl",
    className: "col-span-6",
    type: "video",
    name: "videoUrl",
    usedFileType: 'video/*',
    formType: "file",
    label: "Video",
    placeholder: "Upload Video",
    note: "Maximum 80 MB size allowed for upload.", 
    validation: { required: "Video is required" },
  },
  
  ],
  timeline: [
    {
      fieldName: "Timeline (English)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "text",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (English)",
      placeholder: "",
      validation: { required: "Title (English) is required" },
    },
  ],
  welcomeNote: [
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    // {
    //   fieldName: "Menu Title (EN)",
    //   fieldValue: "",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "",
    //   formType: "input",
    //   label: "Menu Title (EN)",
    //   placeholder: "Enter Menu Title (EN)",
    //   validation: { required: "Menu Title (EN) is required" },
    // },
    // {
    //   fieldName: "Menu Title (MS)",
    //   fieldValue: "",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "",
    //   formType: "input",
    //   label: "Menu Title (MS)",
    //   placeholder: "Enter Menu Title (MS)",
    //   // validation: { required: "Menu Title (MS) is required" },
    // },
    // {
    //   fieldName: "Menu Title (ZH)",
    //   fieldValue: "",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "",
    //   formType: "input",
    //   label: "Menu Title (ZH)",
    //   placeholder: "Enter Menu Title (ZH)",
    //   // validation: { required: "Menu Title (ZH) is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
  ],
  awardsContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740
      }
    },
  ],
  awardsList: [
    {
      fieldName: "Image",
      fieldValue: "bannerImage",
      className: "col-span-6",
      type: "image",
      name: "bannerImage",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 165,
        height: 92
      }
    },
    // {
    //   fieldName: "Year (EN)",
    //   fieldValue: "field_page_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_title_en",
    //   formType: "input",
    //   label: "Title (EN)",
    //   placeholder: "Enter Title (EN)",
    //   validation: { required: "Title (EN) is required" },
    // },
    // {
    //   fieldName: "Year (MS)",
    //   fieldValue: "field_page_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_title_ms",
    //   formType: "input",
    //   label: "Title (MS)",
    //   placeholder: "Enter Title (MS)",
    //   // validation: { required: "Title (MS) is required" },
    // },
    // {
    //   fieldName: "Year (ZH)",
    //   fieldValue: "field_page_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_title_zh",
    //   formType: "input",
    //   label: "Title (ZH)",
    //   placeholder: "Enter Title (ZH)",
    //   // validation: { required: "Title (ZH) is required" },
    // },
    {
      fieldName: "Date",
      fieldValue: "awardsYear",
      className: "col-span-6",
      type: "date",
      name: "awardsYear",
      formType: "date",
      label: "Year",
      placeholder: "Select Year",
      validation: { required: "Year is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  news: [
    {
      fieldName: "Image",
      fieldValue: "newsImage",
      className: "col-span-6",
      type: "image",
      name: "newsImage",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 522,
        height: 348
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Date",
      fieldValue: "date",
      className: "col-span-6",
      type: "date",
      name: "date",
      formType: "date",
      label: "Date",
      placeholder: "Select Date",
      validation: { required: "Date is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  careersContent: [
    {
      fieldName: "Banner Image",
      fieldValue: "bannerImage",
      className: "col-span-6",
      type: "image",
      name: "bannerImage",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
      imageDimension: {
        width: 1920,
        height: 740
      }
    },
    {
      fieldName: "No Vacancy Image",
      fieldValue: "noVancancyImage",
      className: "col-span-6",
      type: "image",
      name: "noVancancyImage",
      formType: "file",
      usedFileType: 'image/*',
      label: "No Vacancy  Image",
      placeholder: "Select No Vacancy  Image",
      imageDimension: {
        width: 500,
        height: 500
      }
      // validation: { required: "No Vacancy  Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
  ],
  storeLocations: [
    {
      fieldName: "Store Locations (English)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "text",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (English)",
      placeholder: "Enter Title (English)",
      validation: { required: "Title (English) is required" },
    },
  ],
  contactDetails:[
    {
      fieldName: "Menu Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Menu Title (EN)",
      placeholder: "Enter Menu Title (EN)",
      validation: { required: "Menu Title (EN) is required" },
    },
    {
      fieldName: "Menu Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Menu Title (MS)",
      placeholder: "Enter Menu Title (MS)",
      // validation: { required: "Menu Title (MS) is required" },
    },
    {
      fieldName: "Menu Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Menu Title (ZH)",
      placeholder: "Enter Menu Title (ZH)",
      // validation: { required: "Menu Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
formDetails: [
  {
    fieldName: "Name (EN)",
    fieldValue: "field_name_en",
    className: "col-span-6",
    type: "text",
    name: "field_name_en",
    formType: "input",
    label: "Name (EN)",
    placeholder: "Enter Name (EN)",
    validation: { required: "Name (EN) is required" },
  },
  {
    fieldName: "Name (MS)",
    fieldValue: "field_name_ms",
    className: "col-span-6",
    type: "text",
    name: "field_name_ms",
    formType: "input",
    label: "Name (MS)",
    placeholder: "Enter Name (MS)",
  },
  {
    fieldName: "Name (ZH)",
    fieldValue: "field_name_zh",
    className: "col-span-6",
    type: "text",
    name: "field_name_zh",
    formType: "input",
    label: "Name (ZH)",
    placeholder: "Enter Name (ZH)",
  },
  {
    fieldName: "Email (EN)",
    fieldValue: "field_email_address_en",
    className: "col-span-6",
    type: "text",
    name: "field_email_address_en",
    formType: "input",
    label: "Email (EN)",
    placeholder: "Enter Email (EN)",
    validation: { required: "Email (EN) is required" },
  },
  {
    fieldName: "Email (MS)",
    fieldValue: "field_email_address_ms",
    className: "col-span-6",
    type: "text",
    name: "field_email_address_ms",
    formType: "input",
    label: "Email (MS)",
    placeholder: "Enter Email (MS)",
  },
  {
    fieldName: "Email (ZH)",
    fieldValue: "field_email_address_zh",
    className: "col-span-6",
    type: "text",
    name: "field_email_address_zh",
    formType: "input",
    label: "Email (ZH)",
    placeholder: "Enter Email (ZH)",
  },
  {
    fieldName: "Mobile Number (EN)",
    fieldValue: "field_mobile_number_en",
    className: "col-span-6",
    type: "text",
    name: "field_mobile_number_en",
    formType: "input",
    label: "Mobile Number (EN)",
    placeholder: "Enter Mobile Number (EN)",
    validation: { required: "Mobile Number (EN) is required" },
  },
  {
    fieldName: "Mobile Number (MS)",
    fieldValue: "field_mobile_number_ms",
    className: "col-span-6",
    type: "text",
    name: "field_mobile_number_ms",
    formType: "input",
    label: "Mobile Number (MS)",
    placeholder: "Enter Mobile Number (MS)",
  },
  {
    fieldName: "Mobile Number (ZH)",
    fieldValue: "field_mobile_number_zh",
    className: "col-span-6",
    type: "text",
    name: "field_mobile_number_zh",
    formType: "input",
    label: "Mobile Number (ZH)",
    placeholder: "Enter Mobile Number (ZH)",
  },
  {
    fieldName: "Category (EN)",
    fieldValue: "field_category_en",
    className: "col-span-6",
    type: "text",
    name: "field_category_en",
    formType: "input",
    label: "Category (EN)",
    placeholder: "Enter Category (EN)",
    validation: { required: "Category (EN) is required" },
  },
  {
    fieldName: "Category (MS)",
    fieldValue: "field_category_ms",
    className: "col-span-6",
    type: "text",
    name: "field_category_ms",
    formType: "input",
    label: "Category (MS)",
    placeholder: "Enter Category (MS)",
  },
  {
    fieldName: "Category (ZH)",
    fieldValue: "field_category_zh",
    className: "col-span-6",
    type: "text",
    name: "field_category_zh",
    formType: "input",
    label: "Category (ZH)",
    placeholder: "Enter Category (ZH)",
  },
  {
    fieldName: "Message (EN)",
    fieldValue: "field_message_en",
    className: "col-span-6",
    type: "text",
    name: "field_message_en",
    formType: "input",
    label: "Message (EN)",
    placeholder: "Enter Message (EN)",
    validation: { required: "Message (EN) is required" },
  },
  {
    fieldName: "Message (MS)",
    fieldValue: "field_message_ms",
    className: "col-span-6",
    type: "text",
    name: "field_message_ms",
    formType: "input",
    label: "Message (MS)",
    placeholder: "Enter Message (MS)",
  },
  {
    fieldName: "Message (ZH)",
    fieldValue: "field_message_zh",
    className: "col-span-6",
    type: "text",
    name: "field_message_zh",
    formType: "input",
    label: "Message (ZH)",
    placeholder: "Enter Message (ZH)",
  },
  {
    fieldName: "Note Text (EN)",
    fieldValue: "field_note_text_en",
    className: "col-span-6",
    type: "text",
    name: "field_note_text_en",
    formType: "input",
    label: "Note Text (EN)",
    placeholder: "Enter Note Text (EN)",
    validation: { required: "Note text (EN) is required" },
  },
  {
    fieldName: "Note Text (MS)",
    fieldValue: "field_note_text_ms",
    className: "col-span-6",
    type: "text",
    name: "field_note_text_ms",
    formType: "input",
    label: "Note Text (MS)",
    placeholder: "Enter Note Text (MS)",
  },
  {
    fieldName: "Note Text (ZH)",
    fieldValue: "field_note_text_zh",
    className: "col-span-6",
    type: "text",
    name: "field_note_text_zh",
    formType: "input",
    label: "Note Text (ZH)",
    placeholder: "Enter Note Text (ZH)",
  },
  {
    fieldName: "Submit Button (EN)",
    fieldValue: "field_submit_en",
    className: "col-span-6",
    type: "text",
    name: "field_submit_en",
    formType: "input",
    label: "Submit Button (EN)",
    placeholder: "Enter Submit Button Text (EN)",
    validation: { required: "Submit button (EN) is required" },
  },
  {
    fieldName: "Submit Button (MS)",
    fieldValue: "field_submit_ms",
    className: "col-span-6",
    type: "text",
    name: "field_submit_ms",
    formType: "input",
    label: "Submit Button (MS)",
    placeholder: "Enter Submit Button Text (MS)",
  },
  {
    fieldName: "Submit Button (ZH)",
    fieldValue: "field_submit_zh",
    className: "col-span-6",
    type: "text",
    name: "field_submit_zh",
    formType: "input",
    label: "Submit Button (ZH)",
    placeholder: "Enter Submit Button Text (ZH)",
  },
],

  contactUs: [
    {
      fieldName: "Menu Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Menu Title (EN)",
      placeholder: "Enter Menu Title (EN)",
      validation: { required: "Menu Title (EN) is required" },
    },
    {
      fieldName: "Menu Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Menu Title (MS)",
      placeholder: "Enter Menu Title (MS)",
      // validation: { required: "Menu Title (MS) is required" },
    },
    {
      fieldName: "Menu Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Menu Title (ZH)",
      placeholder: "Enter Menu Title (ZH)",
      // validation: { required: "Menu Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  homePagePopup: [
    {
      fieldName: "homePagePopup (English)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "text",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (English)",
      placeholder: "Enter Title (English)",
      validation: { required: "Title (English) is required" },
    },
  ],
  jobOpportunities: [
    // {
    //   fieldName: "Image",
    //   fieldValue: "image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image",
    //   placeholder: "Select Image",
    //   validation: { required: "Image is required" },
    // },
    {
      fieldName: "Title (EN)",
      fieldValue: "title_en",
      className: "col-span-6",
      type: "text",
      name: "title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_ms",
      className: "col-span-6",
      type: "text",
      name: "title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_zh",
      className: "col-span-6",
      type: "text",
      name: "title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Start Date",
      fieldValue: "field_start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "field_start_date",
      formType: "dateTime",
      label: "Start Date",
      placeholder: "Select Start Date",
      disabledPreviousDateTime: true
      // validation: { required: "Start Date is required" },
    },
    {
      fieldName: "End Date",
      fieldValue: "field_end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "field_end_date",
      formType: "dateTime",
      label: "End Date",
      placeholder: "Select End Date",
      disabledPreviousDateTime: true
      // validation: { required: "End Date is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],

};
